import React from 'react'
import CloseModal from '../../CloseModal';

interface Props {
    setShowMinNotice: any;
}

const MinNoticeDetails: React.FC<Props> = ({ setShowMinNotice }) => {
  return (
    <div
    className="fixed w-screen h-screen top-0 left-0 zoee-backdrop-filter 
        z-[9001] flex items-center justify-center"
    >
        <div
            className="px-[40px] md:px-[100px] py-[80px] max-h-[90vh] w-[90%] md:w-[800px] max-w-[95%] bg-white 
                    main-shadow rounded-[16px] flex flex-col items-center relative overflow-y-auto"
            >
            <CloseModal
                callback={setShowMinNotice}
                styling={"absolute top-[24px] right-[24px]"}
            />
            <h1 className="text-black text-[18px] md:text-[28px] font-semibold text-center mb-[36px]">
            Minimum Notice
            </h1>
            <div className="w-full flex flex-col gap-[40px] text-center text-[18px]">
            <p className="text-black">
            Ensure smooth scheduling by defining a minimum notice window.
            </p>
         </div>
      </div>
    </div>
  )
}

export default MinNoticeDetails